import React, {Component} from 'react';
import {connect} from 'react-redux';
import SolicitorLayoutHeader from "../../components/solicitorLayoutHeader";
import {getImageFile, incrementImageCounter} from "../../actions/solicitorImages";
import {logout} from "../../actions/user";
import {push} from "connected-react-router";

class SolicitorHeaderHOC extends Component {
	render(){
		return(
            <SolicitorLayoutHeader
                {...this.props}
				notificationsIconCount={this.props.notificationsIconCount}
				images={this.props.solicitorImages}
				incrementImageCounter={this.props.incrementImageCounter}
				imageCounter={this.props.imageCounter}
				fetchedImageIndexes={this.props.fetchedImageIndexes}
				fetchingImages={this.props.fetchingImages}
                logout={this.props.logout}
                push={this.props.push}
                solicitorHomePageInfo={this.props.solicitorHomePageInfo}
                loggedInUserToba={this.props.loggedInUserToba}
                isUserAllowedToCreateApp={this.props.isUserAllowedToCreateApp}
                locationPathName={this.props.locationPathName}
                solicitorGroupAllowedToApplyForDisbursements={this.props.solicitorGroupAllowedToApplyForDisbursements}
            />
		);
	}
}

const mapStateToProps = (state) => {
	return {
	    userRoles: state.user.loggedInUser.roles,
        locationPathName: state.router.location.pathname,
        loggedInUserToba: state.user.loggedInUser.toba,
        notificationsIconCount: state.notifications.notificationsIconCount,
        solicitorImages: state.solicitorImages.images,
        fetchingImages: state.solicitorImages.fetching,
        solicitorFileImages: state.solicitorImages.fileImages,
        imageCounter: state.solicitorImages.imageCounter,
        fetchedImageIndexes: state.solicitorImages.fetchedImageIndexes,
        solicitorHomePageInfo: state.solicitorHomePageInfo.information,
		isUserAllowedToCreateApp: state.user.loggedInUser.allowedToCreateApplications,
        solicitorGroupAllowedToApplyForDisbursements:state.user.loggedInUser.solicitorGroupAllowedToApplyForDisbursements
    }
};

const mapDispatchToProps = (dispatch) => {
	return {
        getImageFile: (url) => {
        	dispatch(getImageFile(url))
		},
        incrementImageCounter: (imageIndex) => {
        	dispatch(incrementImageCounter(imageIndex))
		},
        logout: () => {
            dispatch(logout())
        },
        push: (url) => {
            dispatch(push(url))
        }
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SolicitorHeaderHOC);
